"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.function.name.js");

var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  device: function device(state) {
    return state.app.device;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  developer_uid: function developer_uid(state) {
    return state.user.developer_uid;
  },
  group_id: function group_id(state) {
    return state.user.group_id;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permission_routers: function permission_routers(state) {
    return state.permission.routers;
  },
  addRouters: function addRouters(state) {
    return state.permission.addRouters;
  },
  isVip: function isVip(state) {
    return state.user.isVip;
  },
  userInfo: function userInfo(state) {
    return state.user.userInfo;
  },
  vipLevel: function vipLevel(state) {
    return state.user.vipLevel;
  },
  performanceCount: function performanceCount(state) {
    return state.user.performanceCount;
  },
  email: function email(state) {
    return state.user.email;
  },
  reportDevice: function reportDevice(state) {
    return state.report.reportDevice;
  }
};
var _default = getters;
exports.default = _default;